<template>
    <div class="container">
        <v-img
            class="content"
            max-width="60%"
            :src="require('@/assets/Notes.png')"
        ></v-img>
    </div>
</template>

<script>

export default {
    name: "SecretB"
}
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.content {
    max-width: 60%;
}

</style>